import BCComponent from "./bc_component";
import {bindActionCreators} from "redux";
import {getBonusTasks, submitBonusTask} from "game/app/actions/bonus-tasks-actions";
import connect from "react-redux/es/connect/connect";
import React from "react";

class Oblast1 extends BCComponent {

    render() {
        return (
            <div>
                <h3>Oblast 1 – INTERNET A GRAFIKA</h3>
                <p className='separate-bottom'>Základním zdrojem informací dnešní doby je zajisté internet. K
                    informacím na internetu je však potřeba přistupovat obezřetně, protože <b>nemusí být všechno, co se
                    zde píše, pravdivé</b>. Každou informaci je dobré si ověřit ještě z jiného zdroje. S internetem jsou
                    spojeny různé <b>grafické prvky a obrázky</b>.</p>

                <h4>Znalostní úkoly</h4>
                {this.showTask('internet_grafika_1')}
                {/* {this.showTask('internet_grafika_5')} */}
                <br/>

                <h4>Tvořivé úkoly</h4>                
                {this.showTask('internet_grafika_2')}
                {this.showTask('internet_grafika_6')}
                {/* {this.showTask('internet_grafika_7')} */}
                <br/>

                <h4>Otázky pro dospěláka</h4>
                {/* {this.showTask('internet_grafika_4')} */}
                {this.showTask('internet_grafika_3')}
            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        bonusTasks: state.bonusTasks,
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getBonusTasks: getBonusTasks,
        submitBonusTask: submitBonusTask
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Oblast1);
